import Node from 'nanogl-node';
class Light extends Node {
    constructor() {
        super();
    }
}
export default Light;
